import Vue from "vue";
import Vuex from "vuex";
import { validationRules } from "./utilty/common";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    auth: false,
    user: null,
    credential: "",
    cre: [],
    name: "",
    accessToken: "",
    customerID: 0,
    customerName: "",
    loading: false,
    //noCuntFormType: [19, 24, 25, 26, 27], //api.GetNoCountFormType();から取得する様に修正
    colors: [
      "primary",
      "red",
      "black",
      "red lighten-2",
      "pink lighten-2",
      "purple lighten-2",
      "deep-purple lighten-2",
      "indigo lighten-2",
      "cyan lighten-2",
      "teal lighten-2",
      "green lighten-2",
      "green accent-3",
      "light-green lighten-2",
      "lime lighten-2",
      "yellow",
      "yellow lighten-2",
      "yellow lighten-4",
      "amber lighten-2",
      "orange lighten-2",
      "deep-orange",
      "deep-orange lighten-2",
      "brown lighten-2",
      "blue",
      "blue lighten-2",
      "light-blue lighten-2",
      "blue-grey lighten-2",
      "blue-grey darken-1",
      "grey lighten-2",
    ],
    validation: {
      required: (value) => !!value || "必須項目です",
      numonly: (value) => {
        return /^[0-9]*$/.test(value) || "数値のみ";
      },
      numANDNot: (value) => {
        return /^[&!:0-9]*$/.test(value) || "数値か!のみ";
      },
      cols: (value) => {
        return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
      },
    },
    validationRules: validationRules,
    nullCheck(value) {
      switch (value) {
        case "":
        case "undefined":
        case null:
        case undefined:
        case false:
          return false;
      }

      return true;
    },
  },
  mutations: {
    setAuth(state, auth) {
      state.auth = auth;
    },
    setUser(state, user) {
      state.user = user;
      if (user) {
        state.name = user.username;
      } else {
        state.name = null;
      }
    },
    setCredential(state, id) {
      state.credential = id;
    },
    setCre(state, data) {
      state.cre = data;
    },
    setAccessToken(state, data) {
      state.accessToken = data;
    },
    setCustomerID(state, id) {
      state.customerID = id;
    },
    setCustomerName(state, name) {
      state.customerName = name;
    },
    setLoading(state, bool) {
      state.loading = bool;
    },
    logOut(state) {
      console.log("logOut");
      state.auth = false;
      state.name = null;
      state.credential = null;
      state.customerID = 0;
      state.customerName = "";
      state.cre = null;
      state.accessToken = null;
    },
  },
});
